type TConvertDataToInterval = {
  dateFrom: string
  dateTo: string
  onlyTime?: boolean
}
// получение интервала (string) из двух дат
// param onlyTime:boolean - получение интревала времени

export function convertDataToInterval({
  dateFrom,
  dateTo,
  onlyTime,
}: TConvertDataToInterval): string {
  const fromDate = new Date(dateFrom)
  const toDate = new Date(dateTo)

  const options = {
    day: 'numeric',
    month: 'long',
  } as Intl.DateTimeFormatOptions
  const dayFormat = new Intl.DateTimeFormat('ru-RU', options)
  const currentDay = dayFormat.format(fromDate)

  const timeOptions = {
    hour: '2-digit',
    minute: '2-digit',
  } as Intl.DateTimeFormatOptions
  const fromTime = fromDate.toLocaleTimeString('ru-RU', timeOptions)
  const toTime = toDate.toLocaleTimeString('ru-RU', timeOptions)

  if (onlyTime) {
    return `c ${fromTime} до ${toTime}`
  }
  return `${currentDay} c ${fromTime} до ${toTime}`
}
